const dev = {
  apiBaseUrl: "https://apbe-api.apfym-nonprod.collegeboard.org/bsapbe-dev/",
}

const releasedev = {
  apiBaseUrl:
    "https://apbe-api.apfym-nonprod.collegeboard.org/bsapbe-releasedev/",
}

const perf = {
  apiBaseUrl: "https://apbe-api.apfym-nonprod.collegeboard.org/bsapbe-perf/",
}

const ppbdev = {
  apiBaseUrl: "https://api.apbe-nonprod.collegeboard.org/bsapbe-ppbdev/",
}

const qa = {
  apiBaseUrl: "https://apbe-api.apfym-nonprod.collegeboard.org/bsapbe-qa/",
}

const prod = {
  apiBaseUrl: "https://apbe-api.apfym-prod.collegeboard.org/bsapbe-prod/",
}

const uat = {
  apiBaseUrl: "https://apbe-api.apfym-nonprod.collegeboard.org/bsapbe-uat/",
}

const oat = {
  apiBaseUrl: "https://api.apbe-nonprod.collegeboard.org/bsapbe-oat/",
}

const ppbqa = {
  apiBaseUrl: "https://api.apbe-nonprod.collegeboard.org/bsapbe-ppbqa/",
}

const local = {
  apiBaseUrl: "https://api.apbe-nonprod.collegeboard.org/bsapbe-gk/",
}

const config =
  process.env.REACT_APP_STAGE === "prod"
    ? prod
    : process.env.REACT_APP_STAGE === "oat"
    ? oat
    : process.env.REACT_APP_STAGE === "uat"
    ? uat
    : process.env.REACT_APP_STAGE === "qa"
    ? qa
    : process.env.REACT_APP_STAGE === "ppbqa"
    ? ppbqa
    : process.env.REACT_APP_STAGE === "ppbdev"
    ? ppbdev
    : process.env.REACT_APP_STAGE === "releasedev"
    ? releasedev
    : process.env.REACT_APP_STAGE === "perf"
    ? perf
    : process.env.REACT_APP_STAGE === "dev"
    ? dev
    : local

export default {
  // Add common config values here ...
  ...config,
}
